<template>
  <div class="page-headline">
    <div class="page-headline__contents">
      <Stepper
        v-if="showStepper"
        :steps="steps"
        :step="step"
        class="page-headline__contents--stepper"
      />
      <div>
        <h2 class="page-headline__contents--sub-title">
          まとめてオーダー
        </h2>
        <div class="page-headline__contents--title">
          <PageHeadlineTitle :title="title" />
          <button
            v-if="isShowableButton && isPrimaryButtonType"
            class="page-headline__primary-button"
            @click="onClick"
          >
            <img
              v-if="buttonIconPath"
              :src="buttonIconPath"
              :alt="buttonIconAlt"
              width="20"
              height="20"
            />
            <div class="page-headline__primary-button--label">
              {{ buttonLabel }}
            </div>
          </button>
          <button
            v-if="isShowableButton && isLinkButtonType"
            class="page-headline__button"
            @click="onClick"
          >
            <div class="page-headline__button--label">
              {{ buttonLabel }}
            </div>
            <img
              v-if="buttonIconPath"
              :src="buttonIconPath"
              :alt="buttonIconAlt"
              width="18"
              height="18"
            />
          </button>
        </div>
      </div>
      <BoxListAlertForBulkOrder
        v-if="errorMessages.length > 0"
        :error-messages="errorMessages"
        class="mt-16"
      />
      <BoxListAlert
        v-if="boxListErrorMessages.length > 0"
        class="page-headline__errors mt-16"
      >
        <div v-for="(errorMessage, index) in boxListErrorMessages" :key="index">
          <p>
            {{ errorMessage.message }}
          </p>
          <ul>
            <li
              v-for="(message, i) in errorMessage.items"
              :key="i"
              class="page-headline__errors--items"
            >
              {{ message }}
            </li>
          </ul>
        </div>
      </BoxListAlert>
      <div
        v-if="showNewYearAttention"
        class="buttons-multi page-headline__attention--area mt-16"
      >
        <div class="btn-multi-block btn-multi-expand-block">
          <div
            class="btn-multi btn-multi-expand--active page-headline__attention--header"
          >
            年末年始の営業と納品スケジュールについて
          </div>
          <div
            class="btn-multi-expand__contents page-headline__attention--contents"
          >
            <div class="btn-multi-expand__explanation">
              <p>
                誠に勝手ながら、弊社は2025年12月27日〜2026年1月4日を年末年始休業とさせていただきます。この期間の「まとめてオーダー」に関する各種対応は、2026年1月5日より順次再開いたします。なお、<strong>
                  2025年12月26日の午前中までに弊社にてご入金が確認できたお申し込みにつきましては、2025年内にご納品が可能
                </strong>
                です。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Stepper from '../../atoms/stepper/Stepper.vue'
import PageHeadlineTitle from '../../atoms/headlines/PageHeadlineTitle.vue'
import BoxListAlert from '../../molecules/box_list/BoxListAlert.vue'
import BoxListAlertForBulkOrder from '~/src/js/customer/components/organism/bulk_personal_orders/BoxListAlertForBulkOrder.vue'

export const ButtonType = {
  LINK: 'link',
  PRIMARY: 'primary'
}

export default {
  components: {
    BoxListAlertForBulkOrder,
    Stepper,
    PageHeadlineTitle,
    BoxListAlert
  },
  props: {
    title: {
      type: String,
      required: true
    },
    showStepper: {
      type: Boolean,
      required: false,
      default: true
    },
    step: {
      type: Number,
      required: false,
      default: 1
    },
    buttonType: {
      type: String,
      required: false,
      default: '',
      validator(value, props) {
        if (props?.buttonLabel && props.buttonLabel !== '') {
          return Object.values(ButtonType).includes(value)
        } else {
          return true
        }
      }
    },
    buttonLabel: {
      type: String,
      required: false,
      default: ''
    },
    buttonIconPath: {
      type: String,
      required: false,
      default: ''
    },
    buttonIconAlt: {
      type: String,
      required: false,
      default: ''
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => []
    },
    boxListErrorMessages: {
      type: Array,
      required: false,
      default: () => []
    },
    showNewYearAttention: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      steps: [
        'ギフトカード\n作成',
        'お客様情報\n入力',
        'お申し込み内容\n確認',
        'お申し込み\n完了'
      ]
    }
  },
  computed: {
    isShowableButton() {
      return this.buttonLabel !== ''
    },
    isLinkButtonType() {
      return this.buttonType === ButtonType.LINK
    },
    isPrimaryButtonType() {
      return this.buttonType === ButtonType.PRIMARY
    }
  },
  methods: {
    onClick() {
      this.$emit('clicked')
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline {
  background-color: $white;
  box-sizing: border-box;
  padding: 24px 16px;

  &__contents {
    margin: auto;

    &--title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
    }

    &--sub-title {
      font-size: 1rem;
      font-weight: normal;
      line-height: 1.6;
      color: $black;
      text-align: left;
    }

    &--stepper {
      margin-bottom: 12px;
    }
  }

  &__attention {
    &--area {
      max-width: 343px;
      margin: 16px auto 0 auto;
    }

    &--header {
      text-align: center;
      font-weight: bold;
      line-height: 1.6;
      color: $danger;
      cursor: default;

      &:hover {
        opacity: 1;
      }
    }

    &--contents {
      text-align: left;
    }
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;

    &--label {
      font-size: 1.2rem;
      font-weight: bold;
      line-height: 1.6;
      color: $primary;
    }
  }

  &__primary-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    background-color: $primary;
    padding: 8px 12px;
    height: 36px;
    border-radius: 18px;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }

    &--label {
      font-size: 1.2rem;
      font-weight: bold;
      line-height: 1.6;
      color: $white;
    }
  }

  &__errors {
    & > * {
      margin-bottom: 14px;
    }

    & > *:last-child {
      margin-bottom: 0px;
    }

    &--items {
      list-style: inside;
    }
  }
}
</style>
